import { useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { SCHOOL_LAB_POC_BY_SCHOOL_ID } from "../apiRoutes";

export interface SchoolLabPocItemApi {
  pocName?: string;
  pocPhone?: string;
  pocEmail?: string;
  pocDesignation?: string;
}

export interface SchoolLabPocListResponse {
  data?: SchoolLabPocItemApi[];
}

export const useGetSchoolLabPocBySchoolIdQuery = (
  schoolId: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["schoolLabPoc", schoolId],
    enabled: Boolean(schoolId) && (options?.enabled ?? true),
    queryFn: async () => {
      const res = await axiosAuth.get<SchoolLabPocListResponse>(
        `${SCHOOL_LAB_POC_BY_SCHOOL_ID}${schoolId}/`
      );
      return res.data;
    },
  });
};


